import React from 'react';
import { FadeUp } from '../components/AnimatedSection';
import { useLanguage } from '../context/LanguageContext';

const PrivacyPage = () => {
  const { language, t } = useLanguage();

  const contentEn = (
    <div className="space-y-8 max-w-3xl">
      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Information We Collect</h2>
        <p className="text-[#86868B] leading-relaxed mb-4">
          We may collect the following categories of personal information:
        </p>
        <ul className="text-[#86868B] list-disc list-inside space-y-2">
          <li>Contact details: name, address, phone number, email address</li>
          <li>Financial information: credit card numbers, payment information</li>
          <li>Account information: username, password, preferences</li>
          <li>Transaction information: items viewed, purchased, returned</li>
          <li>Device information: IP address, browser information, unique identifiers</li>
          <li>Usage information: how and when you use our services</li>
        </ul>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">How We Use Your Information</h2>
        <p className="text-[#86868B] leading-relaxed">
          We use your information to provide, personalize, and improve our services, process payments, 
          manage orders, send notifications, process returns, and provide you with a personalized shopping experience.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Data Security</h2>
        <p className="text-[#86868B] leading-relaxed">
          We implement industry-standard security measures to protect your data. All information is 
          encrypted during transfer and storage. However, no security measure is perfect or impenetrable.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Your Rights</h2>
        <p className="text-[#86868B] leading-relaxed mb-4">
          You have the right to:
        </p>
        <ul className="text-[#86868B] list-disc list-inside space-y-2">
          <li>Access your personal data</li>
          <li>Request deletion of your data</li>
          <li>Correct inaccurate data</li>
          <li>Receive a copy of your data</li>
          <li>Opt out of marketing communications</li>
        </ul>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Contact</h2>
        <p className="text-[#86868B] leading-relaxed">
          For questions about this Privacy Policy, contact us at contact.tivorao@gmail.com
        </p>
      </section>
    </div>
  );

  const contentEs = (
    <div className="space-y-8 max-w-3xl">
      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Información que recopilamos</h2>
        <p className="text-[#86868B] leading-relaxed mb-4">
          Podemos recopilar las siguientes categorías de información personal:
        </p>
        <ul className="text-[#86868B] list-disc list-inside space-y-2">
          <li>Datos de contacto: nombre, dirección, número de teléfono, correo electrónico</li>
          <li>Información financiera: números de tarjeta de crédito, información de pago</li>
          <li>Información de cuenta: nombre de usuario, contraseña, preferencias</li>
          <li>Información de transacciones: artículos consultados, comprados, devueltos</li>
          <li>Información del dispositivo: dirección IP, información del navegador</li>
          <li>Información de uso: cómo y cuándo utiliza nuestros servicios</li>
        </ul>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Cómo utilizamos su información</h2>
        <p className="text-[#86868B] leading-relaxed">
          Utilizamos su información para prestar, personalizar y mejorar nuestros servicios, procesar pagos, 
          gestionar pedidos, enviar notificaciones, tramitar devoluciones y ofrecerle una experiencia de compra personalizada.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Seguridad de los datos</h2>
        <p className="text-[#86868B] leading-relaxed">
          Implementamos medidas de seguridad estándar de la industria para proteger sus datos. Toda la información 
          se cifra durante la transferencia y el almacenamiento. Sin embargo, ninguna medida de seguridad es perfecta o infalible.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Sus derechos</h2>
        <p className="text-[#86868B] leading-relaxed mb-4">
          Usted tiene derecho a:
        </p>
        <ul className="text-[#86868B] list-disc list-inside space-y-2">
          <li>Acceder a sus datos personales</li>
          <li>Solicitar la eliminación de sus datos</li>
          <li>Corregir datos inexactos</li>
          <li>Recibir una copia de sus datos</li>
          <li>Darse de baja de las comunicaciones de marketing</li>
        </ul>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#F5F5F7] mb-4">Contacto</h2>
        <p className="text-[#86868B] leading-relaxed">
          Para preguntas sobre esta Política de Privacidad, contáctenos en contact.tivorao@gmail.com
        </p>
      </section>
    </div>
  );

  return (
    <div data-testid="privacy-page" className="min-h-screen bg-black">
      <div className="container-apple section-content pt-32">
        <FadeUp>
          <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight mb-4">
            {t('legal.privacyTitle')}
          </h1>
          <p className="text-[#86868B] mb-12">{t('legal.lastUpdated')}: December 2025</p>
          {language === 'es' ? contentEs : contentEn}
        </FadeUp>
      </div>
    </div>
  );
};

export default PrivacyPage;
